// extracted by mini-css-extract-plugin
module.exports = {"WorkbookContainedMode":"BobWorkbookModeButton_WorkbookContainedMode__2FLej","WorkbookOutlinedMode":"BobWorkbookModeButton_WorkbookOutlinedMode__-Fo1V"};